<template>
<div class="chapter">
<div class="inner_page">
<p class="pl-title">The Founding Father</p>
<p class="pl-author">Diana Palmer</p>
<p class="centerj"><img alt="image" height="55" src="images/logo.jpg" width="58"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// B1_Title.vue?1adf9359